import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { TimeFormat } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

import Tooltip from "../Tooltip";

export default function ETATimeTz({
  date,
  userDate,
  timezone,
}: {
  date: Date;
  timezone: Partial<keyof typeof timeZoneMap>;
  userDate: Date;
}) {
  const { userTimezone } = useTimezone();

  if (timezone === "system") {
    return (
      <span className="relative">
        <FormattedETATime date={date} />
      </span>
    );
  }

  return (
    <span className="relative">
      <Tooltip
        text={<FormattedETATime date={userDate} timezone={userTimezone} />}
        tooltipClassName="w-[100px] flex justify-center"
      >
        <FormattedETATime date={date} timezone={timezone} />
      </Tooltip>
    </span>
  );
}

const FormattedETATime = ({
  date,
  timezone,
}: {
  date: Date;
  timezone?: Partial<keyof typeof timeZoneMap>;
}) => {
  const { getTimezone } = useTimezone();

  if (!dayjs(date).isValid()) {
    return <span></span>;
  }

  // Convert UTC time to specified timezone for display
  const effectiveTimezone = getTimezone(timezone);
  const formatted =
    effectiveTimezone === "system"
      ? dayjs(date).format(TimeFormat.hour_minute)
      : dayjs.utc(date).tz(effectiveTimezone).format(TimeFormat.hour_minute_tz);

  return <span>{formatted}</span>;
};
